import { useEffect, useState } from "react";

import { hslStringToRgbaString } from "@/common/helpers/colors";

export const useFetchZeffyLoaderAnimation = (color: string) => {
  const [animationData, setAnimationData] = useState<Record<string, unknown> | null>(null);
  const animationColor = hslStringToRgbaString(color);

  useEffect(() => {
    const fetchAnimationData = async () => {
      let animationData = await import("./zeffy_loader.json");
      let animationDataString = JSON.stringify(animationData);

      animationDataString = animationDataString.replace(
        /"k":\s*\[\d+(\.\d+)?,\s*\d+(\.\d+)?,\s*\d+(\.\d+)?,\s*1\]/g,
        `"k": ${animationColor}`
      );

      animationData = JSON.parse(animationDataString);

      setAnimationData(animationData);
    };

    fetchAnimationData();

    return () => {
      setAnimationData(null);
    };
  }, [animationColor]);

  return animationData;
};
